import React from 'react'
import styles from 'components/Filters/FilterPanel/filter-panel.module.scss'
import FilterInput from 'components/Filters/FilterInput'
import PropTypes from 'prop-types'

const Input = ({ filterManager, name }) => {
  const { filters, updateFilter, configuration } = filterManager

  return (
    <div className={styles['input-container']}>
      <FilterInput
        filters={filters}
        name={name}
        value={filters?.[name] ?? ''}
        noIcon={configuration?.[name]?.noIcon || false}
        placeholder={configuration?.[name]?.placeholder || ''}
        handleKeyDown={updateFilter}
        handleChangeFilter={updateFilter}
      />
    </div>
  )
}

Input.propTypes = {
  filterManager: PropTypes.object,
  name: PropTypes.string,
}

export default Input
